import React, { useState } from "react";
import { useApp } from "../../context/AppContext";
import { formatDate, timeAgo } from "../../utils/helpers";
import { Shield, Search, Download } from "lucide-react";
import { downloadPDF } from "../../utils/pdf";

export default function AuditLog() {
  const { auditLog, auditIntegrity } = useApp();
  const [search, setSearch] = useState("");
  const filtered = auditLog.filter(e => !search || e.action.toLowerCase().includes(search.toLowerCase()) || e.actor.toLowerCase().includes(search.toLowerCase())).reverse();
  
  const exportAuditPDF = () => {
    downloadPDF("Security Audit Log",
      ["Time", "Actor", "Action", "Details"],
      filtered.map(e => [
        new Date(e.timestamp).toLocaleString("en-IN"),
        e.actor,
        e.action.replace(/_/g, " "),
        e.details ? Object.entries(e.details).map(([k,v]) => k + ": " + v).join(", ") : "—"
      ]),
      [
        { label: "Total Events", value: auditLog.length + "" },
        { label: "Failed Logins", value: auditLog.filter(e => e.action.includes("FAIL")).length + "", color: "#EF4444" },
      ]
    );
  };
  return (
    <div className="page-content">
      <div className="page-header">
        <div><h3>Audit Log</h3><span className="text-muted">{auditLog.length} entries | Chain: {auditIntegrity?.valid ? "\u2705 Intact" : "\u26A0\uFE0F Broken at #"+auditIntegrity?.broken}</span></div>
        <div className="search-box"><Search size={14}/><input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search actions..."/></div>
      </div>
      <div className="table-card">
        <table>
          <thead><tr><th>Time</th><th>Actor</th><th>Action</th><th>Details</th><th>Hash</th></tr></thead>
          <tbody>
            {filtered.slice(0, 100).map(e => (
              <tr key={e.id}>
                <td className="mono" style={{fontSize:11}}>{timeAgo(e.timestamp)}<br/><span style={{color:"var(--t5)"}}>{formatDate(e.timestamp)}</span></td>
                <td className="primary">{e.actor}</td>
                <td><span className="cat-badge">{e.action.replace(/_/g," ")}</span></td>
                <td className="text-muted" style={{fontSize:11,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis"}}>{JSON.stringify(e.details).slice(0,80)}</td>
                <td className="mono" style={{fontSize:10,color:"var(--t5)",maxWidth:100,overflow:"hidden",textOverflow:"ellipsis"}}>{e.prevHash?.slice(0,12)}...</td>
              </tr>
            ))}
            {filtered.length===0 && <tr><td colSpan={5} className="empty-row">No entries found.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}